<template>
  <div class="product-card before-enter" :class="{ editable: product.id != 0 }">
    <editBox
      :option="['edit', 'remove']"
      :item="'product'"
      :itemId="product.id"
      displayMode="vertical_right"
      v-if="product.id != 0"
    />
    <div class="product-new" v-if="isNewProduct()"></div>
    <img
      :src="
        product.id == 0
          ? getImgUrl(product.image)
          : 'https://witrino.com/' + product.image
      "
      alt=""
    />
    <div class="product-detail">
      <div class="score-div">
        <p v-if="product.suggested" class="suggestion">پیشنهادی</p>
        <p class="product-viewed tooltip" v-if="getProductViewed()">
          <span class="tooltiptext">رویت شده</span>
        </p>
      </div>
      <!-- <p class="product-name">
        {{ product.name }}
      </p> -->
      <div class="product-name">
        <animatedText :text="product.name" />
      </div>
      <div class="product-price">
        <div class="product-code">
          <span>
            <p style="min-width: max-content">کد محصول:</p>
            <p class="product-code-value">
              {{ product.code }}
            </p>
          </span>
        </div>
        <p
          v-if="
            (product?.price && getNumbers(product?.price) > 0) ||
            product?.price == 'تماس بگیرید' ||
            product?.price == 'توافقی'
          "
          class="product-sale-price"
          :class="{ price_number: getNumbers(product?.price) > 0 }"
        >
          {{ persianPrice(product.price) }}
        </p>
        <p v-else class="product-sale-unset">...</p>
      </div>

      <div class="bottom-div">
        <div>
          <div class="master-ss">
            <div class="score">
              <p> </p>
              <p></p>
            </div>
            <div class="score">
              <p> </p>
              <p></p>
            </div>

            <div class="score">
              <p> </p>
              <p></p>
            </div>
            <div class="score">
              <p> </p>
              <p></p>
            </div>
            <div class="score">
              <p> </p>
              <p></p>
            </div>
          </div>
        </div>
        <router-link
          class="more-btn"
          :to="'/' + token + '/products/' + product.id"
          >بیشتر</router-link
        >
      </div>
    </div>
    <p class="update_date">آخرین بروزرسانی: {{ dateToJalali() }}</p>
    <div class="off_flag" v-if="product.precent_off"></div>
  </div>
</template>

<script>
import { sellerData } from "@/repo/sellerData.js";
//import * as persianTools from "persian-tools2";
import { addCommas, digitsEnToFa } from "persian-tools2";
import * as moment from "vue-jalali-moment";
import { publicHelpers } from "@/public/helpers";
import editBox from "@/components/editBox/index.vue";
import animatedText from "@/components/animatedText/index.vue";
export default {
  name: "ProductCard",
  components: {
    editBox,
    animatedText,
  },
  mixins: [sellerData, moment, publicHelpers],
  props: ["product"],
  data() {
    return {
      token: null,
    };
  },
  async mounted() {
    await this.$nextTick();
    this.token = this.$route.params.token;
    this.productCardAnimation();
  },
  methods: {
    productCardAnimation() {
      const animatedScrollObserver = new IntersectionObserver(
        (entries, animatedScrollObserver) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("enter");
              //animatedScrollObserver.unobserve(entry.target);
            } else {
              entry.target.classList.remove("enter");
            }
          });
        }
      );

      const productCards = document.getElementsByClassName("product-card");
      //console.log("Start ***********");
      //console.log(productCards);
      [].forEach.call(productCards, (el) => {
        //console.log(el);
        animatedScrollObserver.observe(el);
      });
    },

    getNumbers(numberStr) {
      var persianNumbers = [
          /۰/g,
          /۱/g,
          /۲/g,
          /۳/g,
          /۴/g,
          /۵/g,
          /۶/g,
          /۷/g,
          /۸/g,
          /۹/g,
        ],
        arabicNumbers = [
          /٠/g,
          /١/g,
          /٢/g,
          /٣/g,
          /٤/g,
          /٥/g,
          /٦/g,
          /٧/g,
          /٨/g,
          /٩/g,
        ];
      for (var i = 0; i < 10; i++) {
        numberStr = numberStr
          .replace(persianNumbers[i], i)
          .replace(arabicNumbers[i], i);
      }
      return parseInt(numberStr.replace(/\D/g, ""));
    },
    persianPrice(price) {
      if (price == "تماس بگیرید" || price == "توافقی") return price;
      else {
        price = this.getNumbers(price);
        return digitsEnToFa(addCommas(price));
      }
    },
    getProductViewed() {
      const productId = this.product.id;
      let product_viewed_list = [];
      let productViewedStr = sessionStorage.getItem("product_viewed");

      if (productViewedStr != null && productViewedStr != "") {
        product_viewed_list = productViewedStr.toString().split(",");
        if (
          product_viewed_list.find(function (product) {
            if (product == productId) {
              return true;
            }
            return false;
          })
        ) {
          return true;
        }
      } else {
        return false;
      }
    },

    isNewProduct() {
      const aa = new Date(Date.parse(this.product.created_at));
      // console.log(this.product.created_at);
      // console.log(aa);

      const diffTime = new Date() - aa;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      // console.log(diffDays);
      if (diffDays <= 10) {
        return true;
      }
      return false;
    },
    dateToJalali() {
      const enDate = new Date(
        this.product.updated_at || this.product.created_at || Date.now()
      );
      const faDate = new Intl.DateTimeFormat("fa-IR").format(enDate);
      // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>");
      // console.log(faDate);
      // console.log(enDate);
      // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>");
      return faDate;
    },
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/components/ProductCard/ProductCard.css);
</style>
<style scoped>
.before-enter {
  opacity: 0.5;
  transform: rotateX(80deg);
  perspective-origin: bottom;
  transition: all 0.6s ease-out;
}
.enter {
  opacity: 1;
  transform: rotateX(0deg);
  transition: all 0.6s ease-out;
}
</style>